import {view} from '@sail/ui';

type DarkThemeButtonProps = {
  handleClick: () => void;
  children: React.ReactNode;
};

export const DarkThemeButton = ({
  handleClick,
  children,
}: DarkThemeButtonProps) => {
  return (
    <view.button
      css={{
        width: 'fill',
        color: 'white',
        fontWeight: 'bold',
        fontSize: 'body.small.emphasized',
        backgroundColor: 'black',
        padding: 'small',
        stack: 'x',
        alignX: 'center',
        borderRadius: 'small',
        border: 'none',
        ':hover': {
          opacity: 0.8,
        },
      }}
      onClick={handleClick}
    >
      {children}
    </view.button>
  );
};
